import React from 'react';

interface SmPCProps {
    isOpen: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SmPC: React.FC<SmPCProps> = ({isOpen, setOpen}) => {
  return (
    <div id='smpc'>
        {
            !isOpen ?
            <>
                {/* NOTCH */}
                <div className='fixed w-[220px] h-12 bg-[#e0e6ed] right-10 rounded-bl-lg rounded-br-lg top-0 z-50 flex items-center justify-evenly row' onClick={() => setOpen(!isOpen)}>
                    <div className='col-9 offset-1'>
                        <p className='text-left text-[12px] leading-[1.2em] font-avenir font-medium'>Click here to view the short<br/><b className='font-black'>SmPC for VENCLYXTO</b></p>
                    </div>
                    <div className='col-2'>
                        <img className="w-6" src="/assets/legal/arrow.svg" />
                    </div>
                </div>
            </>
            :
            <>
                {/* POP-UP */}
                <div className='fixed w-full h-full rounded-lg top-0 z-50 flex flex-col items-center row py-6 '>
                        <div className='legal-popup w-3/4 h-full px-10 py-6 flex flex-col items-center justify-between rounded-3xl'>
                            <div className='row w-[98%] flex justify-between text-center items-center'>
                                <h2 className='text-left text-2xl font-avenir font-bold text-white'>Short SmPC for VENCLYXTO</h2>
                                <button 
                                    className='w-24 flex justify-around close-legal p-2 rounded-full text-white items-center font-avenir font-bold text-sm'
                                    onClick={() => setOpen(!isOpen)}
                                >
                                    Close
                                    <img className="w-6" src="/assets/legal/close.svg" />
                                </button>
                            </div>
                            <div className='row w-full object-contain h-full py-2'>
                                <img className="w-full h-[97.5%]" src="/assets/legal/text.svg" />
                            </div>
                        </div>
                </div>
            </>
        }
    </div>
  )
}

export default SmPC